import React, { FunctionComponent } from 'react';
import styles from "./DispositionWhatsappTemplates.module.css";

interface DispositionWhatsappTemplate1Props {}

type Props = {
    msgContent?: any;
};

const DispositionWhatsappTemplate1: FunctionComponent<Props> = ({
    msgContent
}) => {
    const formattedMessage = msgContent
    ?.replace(/\n/g, '<br>') // Replace newlines with <br>
    .replace(
        /(https?:\/\/[^\s]+)/g, // Match URLs
        `<span class="${styles.blueText}">$1</span>`
    )
    .replace(
        /(\b\d{10}\b)/g, // Match 10-digit phone numbers
        `<span class="${styles.blueText}">$1</span>`
    )
    .replace(
        /Dynamic URL/g, // Match the phrase "Dynamic Link"
        `<span class="${styles.blueText}">URL</span>`
    );

    return (
        <div className={styles.TemplateInner}>
            <div
                className={styles.TemplatePara}
                dangerouslySetInnerHTML={{ __html: formattedMessage }}
            />
        </div>
    );
};

export default DispositionWhatsappTemplate1;
